import * as React from 'react';
import { IconProps } from './types';

export const CloseCircleIcon: React.FC<IconProps> = ({
  size = '5',
  color = 'text-interfaceColor-100',
  strokeWidth = 1.2,
  classNames = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`w-${size} h-${size} stroke-current ${color} ${classNames}`}
      fill="none"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="m11.423 6.577-4.846 4.846M6.577 6.577l4.846 4.846M9 16.428A7.429 7.429 0 1 0 9 1.571a7.429 7.429 0 0 0 0 14.857Z"
      />
    </svg>
  );
};
